import { gql } from "graphql-request";

export const VOTES_QUERY = gql`
  query Votes($id: String!) {
    votes(first: 10000, where: { proposal: $id }) {
      id
      ipfs
      voter
      created
      choice
    }
  }
`;

export const PROPOSAL_QUERY = gql`
  query Proposal(
    $id: String!
    $userWallet: String
  ) {
    proposal(
      id: $id
      userWallet: $userWallet
    ) {
      id
      ipfs
      title
      body
      choices
      start
      end
      snapshot
      state
      scores
      scores_state
      scores_by_strategy
      scores_total
      author
      created
      plugins
      network
      votes
      type
      strategies {
        name
        params
      }
      space {
        id
        name
      }
      whitelisted
      whitelist_allowed
    }
  }
`;

export const PROPOSALS_QUERY = gql`
  query Proposals(
    $first: Int!
    $skip: Int!
    $state: String!
    $space: String
    $space_in: [String]
    $author_in: [String]
  ) {
    proposals(
      first: $first
      skip: $skip
      where: {
        space: $space
        state: $state
        space_in: $space_in
        author_in: $author_in
      }
    ) {
      id
      ipfs
      title
      body
      start
      end
      state
      author
      created
      choices
      votes
      space {
        id
        name
        members
        avatar
      }
      strategies {
        name
        params
      }
    }
  }
`;

export const PROPOSAL_VOTES_QUERY = gql`
  query ($id: String!) {
    proposal(id: $id) {
      id
      ipfs
      title
      body
      choices
      start
      end
      snapshot
      state
      author
      created
      plugins
      network
      type
      strategies {
        name
        params
      }
      space {
        id
        name
      }
    }
    votes(first: 10000, where: { proposal: $id }) {
      id
      ipfs
      voter
      created
      choice
    }
  }
`;

export const FOLLOWS_QUERY = gql`
  query Follows($space_in: [String], $follower_in: [String]) {
    follows(where: { space_in: $space_in, follower_in: $follower_in }) {
      id
      follower
      space {
        id
      }
    }
  }
`;

export const SUBSCRIPTIONS_QUERY = gql`
  query Subscriptions($space: String, $address: String) {
    subscriptions(where: { space: $space, address: $address }) {
      id
      address
      space {
        id
      }
    }
  }
`;

export const ALIASES_QUERY = gql`
  query Aliases($address: String!, $alias: String!) {
    aliases(where: { address: $address, alias: $alias }) {
      address
      alias
    }
  }
`;

export const SPACES_QUERY = gql`
  query Spaces($id_in: [String]) {
    spaces(where: { id_in: $id_in }) {
      id
      name
      about
      network
      symbol
      terms
      skin
      avatar
      twitter
      github
      private
      domain
      members
      admins
      plugins
      voting {
        delay
        period
        type
        quorum
      }
      strategies {
        name
        params
      }
      filters {
        minScore
        onlyMembers
      }
    }
  }
`;
